import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithMsalAuth } from "./baseApi";
import type { OrganisationInsightModel, OrganisationTheme } from "@shared/models/organisation";

const controllerName = 'organisation';

interface CustomerOrganisationModel {
  insights: Pick<OrganisationInsightModel, 'id' | 'name' | 'display_name'>[];
}

export const organisationsApi = createApi({
  reducerPath: 'organisationsApi',
  baseQuery: baseQueryWithMsalAuth,
  endpoints: (builder) => ({
    getOrganisation: builder.query<CustomerOrganisationModel, string>({
      query: (id: string) => ({
        url: `${controllerName}/${id}`,
        method: "GET",
      })
    }),
    getOrganisationTheme: builder.query<OrganisationTheme, string>({
      query: (id: string) => ({
        url: `${controllerName}/${id}/theme`,
        method: "GET",
      })
    }),
  })
});

export const {
  useGetOrganisationQuery,
  useLazyGetOrganisationQuery,
  useGetOrganisationThemeQuery,
  useLazyGetOrganisationThemeQuery,
} = organisationsApi;
